module.exports = __webpack_public_path__ + "static/media/instagram-icon.15b83514.svg";